import lowerFirst from './lower-first';
/**
 * @param {string} prefix
 * @param {string} value
 */

var unprefixPropName = function unprefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
};

export default unprefixPropName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/unprefix-prop-name.js
// module id = ./node_modules/bootstrap-vue/esm/utils/unprefix-prop-name.js
// module chunks = 1